import { Pipe, PipeTransform } from '@angular/core';
import { getIconClass } from '@osos/shared/legacy-core';

@Pipe({
  standalone: true,
  name: 'getIconCssClass',
})
export class GetIconCssClassPipe implements PipeTransform {
  transform(icon: string): string {
    return getIconClass(icon);
  }
}
